import * as React from 'react';

import { CircleSpinner } from '@blockworks/ui/legacy/loaders';

import Breadcrumb from '@/components/display/headers/breadcrumb';
import PageHeader from '@/components/display/headers/page-header';
import WebinarsSection from '@/components/pages/webinars/components/webinars-section';
import WebinarsSectionHeader from '@/components/pages/webinars/components/webinars-section-header';
import type { WebinarStripped } from '@/types/article-type';

type WebinarsPageLayoutProps = {
    upcoming: WebinarStripped[];
    pastWebinars: WebinarStripped[];
    isLoading: boolean;
    lastElementRef: (node: HTMLDivElement) => void;
};

const WebinarsPageLayout = (props: WebinarsPageLayoutProps) => {
    const { upcoming, pastWebinars, isLoading, lastElementRef } = props;

    return (
        <div className="w-full p-10">
            <Breadcrumb
                items={[
                    {
                        title: 'Roundtables',
                        link: '/roundtables',
                    },
                ]}
            />
            <PageHeader
                title="Blockworks Roundtables"
                description="Blockworks Roundtables help fund managers, traders, market makers, and institutions explore institutionally focused topics in digital assets."
                className="py-5"
            />
            {upcoming.length > 0 && (
                <>
                    <WebinarsSectionHeader title="Upcoming" />
                    <WebinarsSection webinars={upcoming} category="upcoming" />
                </>
            )}

            {pastWebinars.length > 0 && (
                <>
                    <WebinarsSectionHeader
                        title="On Demand"
                        description="Discover Blockworks archive of past webinars on demand. "
                    />
                    <WebinarsSection webinars={pastWebinars} category="ondemand" lastElementRef={lastElementRef} />
                </>
            )}
            {isLoading && (
                <div className="text-center mt-5">
                    <CircleSpinner />
                </div>
            )}
        </div>
    );
};

export default WebinarsPageLayout;
